export const onboardingStartedAtKey = (orgId) => `onboarding_started_at_${orgId}`;
export const onboardingUseCaseKey = (orgId) => `onboarding_use_case_${orgId}`;
